module.exports = __webpack_public_path__ + "static/musee_olympique_livre3D-4dd13270f9e647e730f0df2e53deedb7.png";